export default "__VITE_ASSET__6ac39ea2__"